import React from 'react';

import {useTranslation} from 'react-i18next';

import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

export const Navigation = () => {
    const {t} = useTranslation();

    return (
        <>
            <NavBar>
                <NavLink exact to={ROUTE.VIRTUAL_WAREHOUSE}>
                    {t('pages.virtualWarehouse.nav.common')}
                </NavLink>
                <NavLink exact to={ROUTE.VIRTUAL_WAREHOUSE_UNGROUPED}>
                    {t('pages.virtualWarehouse.nav.ungrouped')}
                </NavLink>
            </NavBar>
        </>
    );
};
